import OrdersRoutes from './routes'

const Orders = () => (
  <OrdersRoutes />
)

export default Orders
